import React, { useState } from "react";
import { API } from "@/lib/api";

// CMS image with 3 distinct states:
//  - loading  -> neutral skeleton (NEVER the default image)
//  - mediaId  -> the configured CMS image only
//  - no media -> optional hard-coded fallback
// Supports focal point (posX/posY %) and object-fit.
export default function SiteImage({
  mediaId, fallback, loading = false, alt = "", className = "",
  posX = 50, posY = 50, fit = "cover", zoom = 1, style, ...props
}) {
  const [err, setErr] = useState(false);
  if (loading) {
    return <div className={`bg-slate-100 animate-pulse ${className}`} style={style} aria-hidden="true" />;
  }
  const src = mediaId ? `${API}/media/file/${mediaId}` : fallback;
  const finalSrc = err && fallback ? fallback : src;
  if (!finalSrc) return <div className={`bg-slate-100 ${className}`} style={style} />;
  const zoomStyle = zoom && zoom !== 1
    ? { transform: `scale(${zoom})`, transformOrigin: `${posX}% ${posY}%` }
    : {};
  return (
    <img src={finalSrc} alt={alt} className={className} onError={() => setErr(true)}
      style={{ objectFit: fit, objectPosition: `${posX}% ${posY}%`, ...zoomStyle, ...style }} {...props} />
  );
}
